var map = {
	"./books-blue.png": 613,
	"./cancel-blue.png": 614,
	"./clock-blue.png": 615,
	"./flag-blue.png": 616,
	"./gauge-blue.png": 617,
	"./lightbulb-blue.png": 618,
	"./rising-blue.png": 619
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 710;



//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons ^\.\/.*\-blue\.png$
// module id = 710
// module chunks = 0